import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { updateConfig } from "../../../../../store/slices/CMS/cmsSlice";

const useComponentForm = (basicData, formik) => {
  const dispatch = useDispatch();
  const { editHomePageData, componentIndex, characters, selectedSlug } =
    useSelector((state) => state.cms);

  let selectedOptions = basicData?.data?.dropdown_list[selectedSlug]?.map(
    ({ _id, name }) => ({
      value: _id,
      label: name,
    })
  );
  useEffect(() => {
    if (editHomePageData !== "" && editHomePageData) {
      formik.setValues({
        title: editHomePageData?.title ?? "",
        alias_title: editHomePageData?.alias_title ?? "",
        selected_items: editHomePageData?.selected_items ?? "",
      });
    }
    //eslint-disable-next-line
  }, [editHomePageData]);

  const handleSelect = (value) => {
    formik?.setFieldValue("selected_items", value?.value || null);
    let updatedData = characters?.map((character, index) => {
      if (index === componentIndex) {
        return {
          ...character,
          selected_items: value?.value,
        };
      }
      return character;
    });
    dispatch(
      updateConfig((state) => {
        state.characters = updatedData;
      })
    );
  };

  return {
    componentIndex,
    editHomePageData,
    selectedOptions,
    handleSelect,
  };
};
export default useComponentForm;
